import { useEffect, useRef, useState } from 'react';

const reviews = [
  {
    name: '小漫迷',
    avatar: '/images/avatars/review-1.webp',
    content: '用了天天漫画三年多了，界面超级舒服，更新速度也很快。每天睡前都要刷几章，已经成为生活中不可缺少的一部分了！智能推荐功能每次都能给我惊喜，发现了很多宝藏作品。',
    rating: 5,
    date: '2026-08-15',
    tag: '忠实用户',
  },
  {
    name: '追番达人',
    avatar: '/images/avatars/review-2.webp',
    content: '天天漫画的阅读体验是我用过所有漫画APP里最好的。横竖屏切换流畅，画质清晰，加载速度快。离线缓存功能对于通勤族来说简直是神器！',
    rating: 5,
    date: '2026-08-10',
    tag: '深度用户',
  },
  {
    name: '二次元少女',
    avatar: '/images/avatars/review-3.webp',
    content: '推荐算法太准了！每次打开天天漫画都能发现新的宝藏作品，再也不用漫荒了。社区氛围也很好，可以跟同好一起讨论剧情，分享推荐。',
    rating: 5,
    date: '2026-08-05',
    tag: '活跃用户',
  },
  {
    name: '漫画老司机',
    avatar: '/images/avatars/review-4.webp',
    content: '作为一个看了二十多年漫画的老读者，天天漫画的正版资源非常丰富，很多冷门神作都有收录。而且阅读器的专业度很高，比不少海外同类产品还强。',
    rating: 5,
    date: '2026-07-28',
    tag: '资深漫迷',
  },
  {
    name: '学生党小K',
    avatar: '/images/avatars/review-5.webp',
    content: '天天漫画APP下载后真的停不下来！界面简洁好看，没有乱七八糟的广告。免费用户也能看大部分内容，学生党表示非常满意。',
    rating: 5,
    date: '2026-07-20',
    tag: '新用户',
  },
  {
    name: '宝妈画酱',
    avatar: '/images/avatars/review-6.webp',
    content: '夜间模式对孩子的眼睛很友好，我会和孩子一起看治愈系的漫画。天天漫画的亲子漫画分类很贴心，希望能出更多适合家庭阅读的内容。',
    rating: 5,
    date: '2026-07-15',
    tag: '家庭用户',
  },
];

function ScrollReveal({ children, className = '' }: { children: React.ReactNode; className?: string }) {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setVisible(true); observer.unobserve(el); } },
      { threshold: 0.1 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  return (
    <div ref={ref} className={`transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'} ${className}`}>
      {children}
    </div>
  );
}

export default function Reviews() {
  return (
    <div className="min-h-screen bg-white pt-20">
      <section className="px-4 md:px-8 lg:px-16 xl:px-24 py-20 md:py-28">
        <div className="max-w-6xl mx-auto">
          <ScrollReveal>
            <div className="text-center mb-20">
              <span className="inline-block px-4 py-1.5 rounded-full bg-pink-50 text-pink-600 text-sm font-medium mb-4">
                用户评价
              </span>
              <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
                他们都在用天天漫画
              </h1>
              <p className="text-gray-500 text-lg max-w-2xl mx-auto">
                天天漫画以优质的阅读体验和丰富的漫画资源，赢得了千万用户的信赖与好评。听听他们怎么说。
              </p>
            </div>
          </ScrollReveal>

          {/* Rating Overview */}
          <ScrollReveal>
            <div className="border border-gray-100 p-8 md:p-12 mb-12">
              <div className="grid md:grid-cols-3 gap-8 items-center">
                <div className="text-center">
                  <p className="font-serif text-5xl font-bold text-pink-500 mb-2">4.9</p>
                  <div className="flex items-center justify-center gap-1 mb-2">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-amber-400 text-lg" />
                    ))}
                  </div>
                  <p className="text-sm text-gray-400">综合评分</p>
                </div>
                <div className="md:border-x md:border-gray-100 md:px-8">
                  <div className="text-center">
                    <p className="font-serif text-5xl font-bold text-pink-500 mb-2">500万+</p>
                    <p className="text-sm text-gray-400">累计下载用户</p>
                  </div>
                </div>
                <div className="text-center">
                  <p className="font-serif text-5xl font-bold text-pink-500 mb-2">99.9%</p>
                  <p className="text-sm text-gray-400">用户好评率</p>
                </div>
              </div>
            </div>
          </ScrollReveal>

          {/* Reviews Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {reviews.map((review) => (
              <ScrollReveal key={review.name}>
                <div className="border border-gray-100 p-6 md:p-8 h-full flex flex-col">
                  <div className="flex items-center gap-1 mb-4">
                    {Array.from({ length: review.rating }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-amber-400 text-sm" />
                    ))}
                  </div>
                  <p className="text-gray-600 text-sm leading-relaxed mb-6 flex-1">{review.content}</p>
                  <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-full overflow-hidden bg-pink-100">
                        <img src={review.avatar} alt={review.name} className="w-full h-full object-cover" />
                      </div>
                      <div>
                        <p className="text-sm font-bold text-gray-900">{review.name}</p>
                        <p className="text-xs text-gray-400">{review.date}</p>
                      </div>
                    </div>
                    <span className="px-3 py-1 rounded-full bg-pink-50 text-pink-600 text-xs font-medium">
                      {review.tag}
                    </span>
                  </div>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}